import React from "react";
import Iframe from "react-iframe";
import { CLICK_UP_RELEASE_NOTES_URL } from "../../utils/constants";
import { Nav } from "../commons/nav";

export const ReleaseNotes = () => {
  return (
    <div id="wrapper">
      <div className="release-notes-container">
        <div className="nav-holder">
          <Nav />
        </div>
        <div className="release-notes-holder">
          <Iframe
            url={`${CLICK_UP_RELEASE_NOTES_URL}`}
            width="100%"
            height="1000px"
            display="block"
          />
        </div>
      </div>
    </div>
  );
};
